<div class="container dd-checkout-pay">
  <p>
    <button type="button" class="button" (click)="cancel()">Back to checkout</button>
  </p>

  @if (loading()) {
    <p>Loading payment…</p>
  }

  @if (error()) {
    <p class="woocommerce-error">{{ error() }}</p>
    <p><a class="button" routerLink="/checkout">Return to checkout</a></p>
  }

  <div #checkoutMount class="dd-checkout-pay__stripe" [hidden]="!!error()"></div>
</div>
